module.exports = __webpack_public_path__ + "static/media/1.eda81640.png";